// @flow
import React from 'react'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import ImagePreviewContainer from '../../ImagePreviewContainer'
import ResponsibleRect from '../ResponsibleRect'
import { alertColor, grayColor } from '../../controls/colors'
import Tooltip from '../../Tooltip'
import PrimaryButton from '../../controls/PrimaryButton'
import type { CarouselCard } from '../../../redux/ducks/carouselEdit/reducers'

export type Props = {|
  storeId: string, // eslint-disable-line react/no-unused-prop-types
  cards: Array<CarouselCard>,
  currentIndex: number,
  onCurrentIndexChange: (number) => void,
  onAdd: () => void,
  onRemove: (number) => void,
  hasCardError: Array<boolean>
|}

const cardWidth = 80

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  display: flex;
`
const StringBeginning: StyledComponent<Object, any, any> = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 14px;
  height: 18px;
`
const CardWrapper: StyledComponent<
  { isDanger?: boolean, isActive?: boolean },
  any,
  any
> = styled.div`
  width: ${cardWidth + 12}px;
  padding: 5px;
  position: relative;
  cursor: pointer;
  border: solid 1px ${({ isDanger }) => (isDanger ? alertColor : grayColor)};
  background-color: ${({ isActive }) => (isActive ? '#def' : 'white')};
`
const Button: StyledComponent<Object, any, any> = styled.div`
  width: ${cardWidth + 12}px;
  border: solid 1px ${grayColor};
  cursor: pointer;
  align-items: center;
  display: flex;
  user-select: none;
`
const ButtonText: StyledComponent<Object, any, any> = styled.div`
  text-align: center;
`
const CardNumber: StyledComponent<Object, any, any> = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
  font-size: 20px;
  border-radius: 10px;
  background-color: white;
  padding: 15px;
`
const ImageWrapper: StyledComponent<Object, any, any> = styled.div`
  position: relative;
`
const maxCardsCount = 6

const t = {
  add_card: 'Добавить карточку',
  remove_card: 'Удалить карточку'
}

export default function CardSelector(props: Props) {
  return (
    <Wrapper>
      {_.map(props.cards, (card, index: number) => (
        <Tooltip
          key={index}
          content={
            <PrimaryButton small onClick={() => props.onRemove(index)}>
              {t.remove_card}
            </PrimaryButton>
          }
          isInteractive
          position="top"
        >
          <CardWrapper
            className={`t-Carousel__SelectCard_${index}`}
            isActive={index === props.currentIndex}
            isDanger={props.hasCardError[index]}
            onClick={() => props.onCurrentIndexChange(index)}
          >
            <StringBeginning>{card.title}</StringBeginning>
            <StringBeginning>{card.description}</StringBeginning>
            <ImageWrapper>
              {card.imageStoreId ? (
                <ImagePreviewContainer storeId={card.imageStoreId} width={cardWidth} />
              ) : (
                <ResponsibleRect width={cardWidth} color="white" ratio={1} />
              )}
              <CardNumber>#{index + 1}</CardNumber>
            </ImageWrapper>
            <StringBeginning>{card.url}</StringBeginning>
          </CardWrapper>
        </Tooltip>
      ))}
      {props.cards.length < maxCardsCount && (
        <Button onClick={() => props.onAdd()}>
          <ButtonText className="t-Carousel__AddCard">{t.add_card}</ButtonText>
        </Button>
      )}
    </Wrapper>
  )
}
